import React from "react";
import Logo from "_components/Logo/Logo";
import { useSelector } from "react-redux";
import { NavItemType } from "../../type";
import Link from "_components/Link";

const Footer: React.FC = () => {

  const { footer } = useSelector((state: any) => state.menu);
  const renderWidgetMenuItem = (menu: NavItemType, index: number) => {
    return (
      <div key={index} className="text-sm">
        <h2 className="font-semibold text-neutral-700 dark:text-neutral-200">
          {menu.name}
        </h2>
        <ul className="mt-5 space-y-4">
          {menu.children?.map((item: NavItemType, index) => (
            <li key={index}>
              <Link
                key={index}
                className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
                href={item.href}
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="nc-Footer relative py-16 lg:py-28 border-t border-neutral-200 dark:border-neutral-700">
      <div className="container grid grid-cols-2 gap-y-10 gap-x-5 sm:gap-x-8 md:grid-cols-4 lg:grid-cols-5 lg:gap-x-10 ">
        <div className="grid grid-cols-4 gap-5 col-span-2 md:col-span-4 lg:md:col-span-1 lg:flex lg:flex-col">
          <div className="col-span-2 md:col-span-1">
            <Logo />
          </div>
        </div>
        {footer.map(renderWidgetMenuItem)}
      </div>
    </div>
  );
};

export default Footer;
